module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.selectorActive),
      callback: function($$v) {
        _vm.selectorActive = $$v
      },
      expression: "selectorActive"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Questions",
      "name": "questions"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Questions")])]), _vm._v(" "), _c('question-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "templates"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Template for choices")])]), _vm._v(" "), _c('choice-template-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "choices"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Choices")])]), _vm._v(" "), _c('choice-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a079be14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/QualitativeSelectorTab.vue
// module id = 3375
// module chunks = 3